import { useState } from 'react';
import { MediabankFile } from '../../Types/mediabank';
import { SelectedFileCallback } from './BizMediabankContext';
import { BizButton } from '../Mini/BizButton';
import MediaCatalogBrowser from './MediaCatalogBrowser';
import { MediaContentCategory } from '../../Types/mediaCatalog';
import { useTranslation } from 'react-i18next';

export default function MediabankDialogSelect({
	onClose,
	initialType = 2,
	initialCategory,
	legacy,
}: {
	onClose: SelectedFileCallback;
	initialType?: number;
	initialCategory?: MediaContentCategory;
	legacy?: boolean;
}) {
	const { t } = useTranslation();
	const [selected, setSelected] = useState<MediabankFile | null>(null);
	return (
		<div className='bizmediabank-react-dialog-select'>
			<MediaCatalogBrowser
				onSelect={setSelected}
				onConfirmSelect={onClose}
				selectedFileId={selected?.Id}
				initialType={initialType}
				initialCategory={initialCategory}
				legacy={legacy}
			/>
			<div className='file-buttons'>
				<BizButton text={t('GLOBAL.CANCEL')} onClick={() => onClose(undefined)} legacy={legacy} />
				<BizButton
					text={t('MEDIABANK.SELECT_FILE')}
					disabled={!selected}
					isLead={Boolean(selected)}
					onClick={() => {
						if (selected) onClose(selected);
					}}
					legacy={legacy}
				/>
			</div>
		</div>
	);
}
